document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_CartItems', () => {
    return {
      itemsRoot: null,
      locked: null,
      init() {
        this.itemsRoot = this.$root;

        window.addEventListener('shapes:modalcart:afteradditem', (e) => {
          const sections = e.detail?.response?.sections;
          const cartItemsHtml = sections?.['cart-items'];
          if (!cartItemsHtml) return;
          const wrapper = querySelectorInHTMLString('[data-cart-items]', cartItemsHtml);
          if (!wrapper) return;
          Alpine.morph(this.itemsRoot, wrapper.outerHTML);
        });

        window.addEventListener('shapes:modalcart:cartqtychange', (e) => {
          const sections = e.detail?.response?.sections;
          const cartItemsHtml = sections?.['cart-items'];
          if (!cartItemsHtml) return;
          const wrapper = querySelectorInHTMLString('[data-cart-items]', cartItemsHtml);
          if (!wrapper) return;
          Alpine.morph(this.itemsRoot, wrapper.outerHTML);
          this.$nextTick(() => {
            this.itemsRoot.querySelectorAll('input').forEach((inputEl) => {
              inputEl.value = inputEl.getAttribute('value');
            });
          });

          const cartLiveRegionHtml = sections?.['cart-live-region'];
          if (cartLiveRegionHtml) {
            const liveEl = parseDOMFromString(cartLiveRegionHtml).firstElementChild;
            const cartStatus = document.getElementById('cart-live-region-text');
            if (liveEl && cartStatus) {
              cartStatus.textContent = liveEl.textContent;
              cartStatus.setAttribute('aria-hidden', false);
            }
          }

          if (e.detail.originalTarget) {
            this.$nextTick(() => {
              if (!this.itemsRoot.contains(e.detail.originalTarget)) {
                let focusRoot;

                if (this.itemsRoot.closest('[role="dialog"]')) {
                  focusRoot =
                    this.itemsRoot.closest('[role="dialog"]').parentNode;
                } else {
                  focusRoot = this.itemsRoot;
                }

                this.$focus.within(focusRoot).first();
              }
            });
          }
        });
      },
      itemQuantityChange(key, value) {
        if (this.locked) return;

        const lineItemEl = this.$el.closest('li[data-cart-item-key]');
        const id = key ? key : lineItemEl.getAttribute('data-cart-item-key'),
          quantity = parseInt(!isNaN(value) ? value : this.$el.value, 10),
          sections = 'cart-items,cart-footer,cart-item-count,cart-live-region';

        const config = fetchConfigDefaults('json');
        config.body = JSON.stringify({
          id,
          quantity,
          sections,
          sections_url: window.location.pathname,
        });

        const changeUrl = (theme.routes.cart_change_url || '/cart/change').replace(/\.js$/, '') + '.js';

        const lastValue = parseInt(this.$el.dataset.lastValue, 10);

        if (quantity !== lastValue) {
          lineItemEl.classList.add('opacity-50', 'cursor-progress');

          const currentCount = Alpine.raw(Alpine.store('cart_count').count);

          this.locked = lineItemEl;

          fetch(changeUrl, config)
            .then((res) => res.json())
            .then((data) => {
              if (data.status === 422) {
                const errorEl = lineItemEl.querySelector(
                  '[data-cart-quantity-error]'
                );

                errorEl.textContent = data.message;

                errorEl.style.display = '';
                lineItemEl.classList.remove('opacity-50', 'cursor-progress');

                this.$el.value = lastValue;
              } else {
                if (data.item_count !== undefined && window.Alpine?.store?.cart_count) {
                  window.Alpine.store('cart_count').count = parseInt(data.item_count, 10);
                }
                document.body.dispatchEvent(
                  new CustomEvent('shapes:modalcart:cartqtychange', {
                    bubbles: true,
                    detail: { response: data, originalTarget: lineItemEl },
                  })
                );
              }
            })
            .catch(() => {
              document.getElementById('cart-errors').textContent =
                theme.strings.cartError;
            })
            .finally(() => {
              this.locked = null;
            });
        }
      },
      removeItem(key) {
        this.itemQuantityChange(key, 0);
      },
      _adjustQty(el, operation) {
        const inputEl = el
          .closest('li[key]')
          .querySelector('input[type="number"]');

        const lastValue = parseInt(inputEl.dataset.lastValue, 10);

        let newValue;

        if (operation == 'increment') {
          newValue = lastValue + 1;
        }

        if (operation == 'decrement') {
          if (lastValue > 1) {
            newValue = lastValue - 1;
          } else {
            newValue = 1;
          }
        }

        if (operation == 'remove') {
          newValue = 0;
        }

        inputEl.value = newValue;

        // this.$nextTick(() => {
        inputEl.dispatchEvent(new Event('change', { bubbles: true }));
        // });
      },
      increment() {
        this._adjustQty(this.$el, 'increment');
      },
      decrement() {
        this._adjustQty(this.$el, 'decrement');
      },
      remove() {
        this._adjustQty(this.$el, 'remove');
      },
    };
  });
});
